import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import duck from 'assets/images/icon-duck.png';
import { shuffleArray } from 'utils/helpers';

const CountingDucks: FC = () => {

  const { t } = useTranslation()

  const [obj, setObj] = useState(null);

  const [items, setItems] = useState([]);
  const [ducks, setDucks] = useState([]);
  const [ok, setOk] = useState(false);
  const [pos, setPos] = useState({})




  useEffect(() => {        
    let firstItems = [1,2,3,4,5,6,7,8,9];
    setItems(firstItems);
    let newItems = [...firstItems];
    shuffleArray(newItems);
    setDucks(newItems.slice(0,3));
  }, []) 


  const handleDragEnter = e => {

    e.preventDefault();
    e.stopPropagation();

    const newPos = {...pos}
    newPos[e.target.id] = obj
    setPos(newPos)
   
    let ok=true;
    for(const d of ducks)
        if(newPos[d] != d)ok=false;
    if(ok)
        setOk(true)
  };



  return (
    <>
      <div style={{ 
        background: '#fff',
        padding: '40px',
        textAlign: 'center'
      }}>
            {ok ? <div>
                <div style={{ marginBottom: '40px', fontSize: '50px', color: 'orange' }}>{t('dashboard.ducks-well-done')}</div>
            </div> : 
            
            <div style={{ paddingBottom: '50px' }}>
                <div style={{ marginBottom: '40px', fontSize: '50px', color: 'orange' }}>{t('dashboard.ducks-title')}</div>
                <div style={{ fontSize: '20px', marginBottom: '50px' }}>{t('dashboard.ducks-text')}</div>

          
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                              
                                {items.map((item,idx) => <div key={idx}>
                                    {ducks.includes(item) 
                                            ? <div style={{ width: '50px', height: '50px', textAlign: 'center',  
                                              background: pos[item] == item ? '#fff' : '#ccc' }}

                                            id={item}
                                            onClick={e => handleDragEnter(e)}
                                            onDragEnter={e => handleDragEnter(e)}
                                            >
                                              {pos[item] == item && <>
                                                <img src={duck} style={{ height: '50px' }} />
                                                <div style={{ fontSize: '20px', fontWeight: 'bold', position: 'relative', top: '-10px'  }}>{item}</div>
                                              </>}
                                                
                                            </div> 
                                            : <div style={{ textAlign: 'center', width: '50px', height: '50px' }}>
                                                    <img src={duck} style={{ height: '50px' }} />
                                                    <div style={{ fontSize: '20px', fontWeight: 'bold', position: 'relative', top: '-10px'  }}>{item}</div>
                                            </div>}
                                </div>)}

                            </div>


                            <div style={{ marginTop: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }} >
                              {ducks.filter(item => !(item in pos) || pos[item] != item).map((item,idx) => <div 
                                key={idx} 
                                id={idx.toString()}
                                className="thing" 
                                draggable="true"
                                onClick={(e) => {
                                  setObj(item)
                                }}
                                onDragStart={(e) => {
                                  setObj(item)
                                }}
                                onDragEnd={(e) => {
                                  setObj(null)
                                }}
                                
                                >
                                            <div style={{ textAlign: 'center', width: '50px' }} >
                                                    <img src={duck} style={{ height: '50px' }} 
                                                      className={`${obj == item ? 'duck-selected' : ''}`}/>
                                                    <div style={{ fontSize: '20px', fontWeight: 'bold', position: 'relative', top: '-10px'  }}>{item}</div>
                                            </div>
                                </div>)}
                            </div>            

                        


            </div>

            }

      </div>
    </>
  )
}

export default CountingDucks
